import React from "react";
import {
  MosaicLayout,
  MosaicLayoutProps
} from "@silversea-ssc/ui-components-react";
import LinkPictureCard from "components/Card/LinkPictureCard";
import { CollectionMosaicShipFragment } from "types/graphql-types";
import {
  FilterByType,
  filterByShipType
} from "components/CollectionSlider/utils";
import CardTag from "components/CardTags/CardTag";
import { Trans } from "@lingui/react/macro";

interface ShipsMosaicProps extends MosaicLayoutProps {
  filterByType: FilterByType;
  data: CollectionMosaicShipFragment[];
}

const ShipsMosaic: React.FC<React.PropsWithChildren<ShipsMosaicProps>> = ({
  filterByType,
  data,
  ...props
}) => {
  const ships = filterByShipType(data, filterByType);

  return (
    <MosaicLayout {...props} data-content-name="ships_mosaic">
      {ships.map((item) => {
        return (
          <LinkPictureCard
            borderColor="transparent"
            key={item._id}
            action={{ href: item.fullPath }}
            title={item.card?.title?.localized || ""}
            image={item.card?.image}
            trackingName={item.metadata?.tracking?.name}
            tags={
              item.shipType == "Expedition" ? (
                <CardTag backgroundColor="expedition">
                  <Trans>Expedition Ship</Trans>
                </CardTag>
              ) : undefined
            }
          />
        );
      })}
    </MosaicLayout>
  );
};

export default ShipsMosaic;
